import BaseHttpService from "../baseService";

class GeneralServiceProvider extends BaseHttpService {
	constructor() {
		super("general");
	}

	/**
	 * Current assets price
	 *
	 * @async
	 * @version 1.0.0
	 */
	public file(id: string) {
		return this.getResource().get(`/file/${id}?t=${new Date().getTime()}`, { responseType: "arraybuffer" });
	}

	/**
	 * Get services version
	 *
	 * @async
	 * @version 1.0.0
	 */
	public ver(): HttpService.BaseResponse {
		return this.getResource().get("version");
	}
}

const GeneralService = new GeneralServiceProvider();

export default GeneralService;
